import { CustomerServiceOutlined, ExceptionOutlined, WechatOutlined, BookOutlined } from "@ant-design/icons";
import { PERMISSION } from "../constants";
import { APP_PATH } from "constants/path";
import React from "react";
import { lazyRetry } from "utils/route";
import MerchantRequestList from "features/merchant-request";

const MerchantRequestCreate = React.lazy(() =>
	lazyRetry(() => import("../features/merchant-request/MerchantRequestCreate")),
);

const ContactSupports = React.lazy(() =>
	lazyRetry(() => import("../features/request-services/contact-support")),
);
const ContactSupport = React.lazy(() =>
	lazyRetry(
		() =>
			import(
				"../features/request-services/contact-support/components/ContactSupport"
			),
	),
);

const FormRequestList = React.lazy(() =>
	lazyRetry(() => import("../features/webapp/form-request")),
);
const FormRequestDetail = React.lazy(() =>
	lazyRetry(() => import("../features/webapp/form-request/FormRequestDetail")),
);

const LoanApplicationList = React.lazy(() =>
	lazyRetry(() => import("../features/webapp/loan-application")),
);

const LoanApplicationDetail = React.lazy(() =>
	lazyRetry(() => import("../features/webapp/loan-application/detail")),
);

const RequestServiceRoutes = {
	label: "Request service",
	path: "",
	key: "request-services",
	icon: <CustomerServiceOutlined />,
	permissions: [],
	children: [
		{
			label: "Contact supports",
			path: `${APP_PATH.contactSupports}`,
			key: "contact-supports",
			children: [],
			icon: <ExceptionOutlined />,
			component: <ContactSupports />,
			permissions: [],
		},
		{
			label: "Contact supports",
			path: `${APP_PATH.contactSupport}`,
			key: "contact-supports",
			children: [],
			hidden: true,
			component: <ContactSupport />,
			permissions: [],
		},

    	// merchant request
		{
			label: "Merchant request",
			path: APP_PATH.transactionMerchantRequest,
			key: "transaction-merchant-request",
			icon: <WechatOutlined />,
			component: <MerchantRequestList />,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
		},
		{
			label: "Merchant request detail",
			path: `${APP_PATH.transactionMerchantRequest}/:id`,
			key: "",
			icon: <WechatOutlined />,
			component: <MerchantRequestCreate />,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
			hidden: true,
		},

    // form-request
    {
      label: "Customer request",
      key: "form-request",
      icon: <BookOutlined />,
      component: <FormRequestList />,
      children: [],
      path: APP_PATH.formRequest,
      permissions: [PERMISSION.CUSTOMER_REQUEST.VIEW],
    },
    {
      label: "Customer Request",
      key: "",
      component: <FormRequestDetail />,
      path: `${APP_PATH.formRequest}/:id`,
      hidden: true,
      permissions: [
        PERMISSION.CUSTOMER_REQUEST.VIEW,
        PERMISSION.CUSTOMER_REQUEST.UPDATE,
      ],
    },
    {
      label: "Loan Application",
      key: "",
      icon: <BookOutlined />,
      component: <LoanApplicationList />,
      path: `${APP_PATH.loanApplications}`,
      permissions: [
        PERMISSION.CUSTOMER_REQUEST.VIEW,
      ],
    },
    {
      label: "Loan Application",
      key: "",
      component: <LoanApplicationDetail />,
      path: APP_PATH.loanApplicationDetail,
      hidden: true,
      permissions: [
        PERMISSION.CUSTOMER_REQUEST.VIEW,
				PERMISSION.CUSTOMER_REQUEST.UPDATE,
      ],
    },
	],
};

export default RequestServiceRoutes;
